module.exports = __webpack_public_path__ + "static/kiratech-svizzera-logo_ok-01-bce56eb9e8bb4b0fdd7593ccba229a63.png";